import { SimpleDatePipe } from 'src/app/pipes/simple-date.pipe';
import { AgePipe } from './../../../pipes/age.pipe';
import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription, timer } from 'rxjs';
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { Region } from 'src/app/model/region.model';
import { School, Grade } from 'src/app/model/school.model';
import { PagingService } from 'src/app/service/paging.service';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { EnrollmentReportResult, EnrollmentReportStudent, EnrollmentReportRegion } from './model/enrollment-report-result.model';
import { EnrollmentReportService } from './service/enrollment-report.service';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ApiExportsService } from 'src/app/service/api-exports.service';
import { UtilityService } from 'src/app/service/utility.service';
import { RegionDataService } from 'src/app/component/common-components/service/region-data.service';
import { RegionDropdownComponent } from '../../common-components/region/region-dropdown/region-dropdown.component';
import { DistrictDropdownComponent } from '../../common-components/district/district-dropdown/district-dropdown.component';
import { ThemePalette } from '@angular/material/core';
import { ChosenRegion, ChosenSchoolDistrict } from '../counts/model/student-eligibility-count';
import { CountyDropdownComponent } from '../../common-components/county/county-dropdown/county-dropdown.component';
import { SchoolDropdownComponent } from '../../common-components/school/school-dropdown/school-dropdown.component';
import { DistrictDataService } from '../../common-components/service/district-data.service';

@Component({
    selector: 'enrollment-report',
    templateUrl: './enrollment-report.component.html',
    styleUrls: ['./enrollment-report.component.scss']
})
export class EnrollmentReportComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    @ViewChild('appRegionCode') appRegionCode!: RegionDropdownComponent;
    @ViewChild('appCountyCode') appCountyCode!: CountyDropdownComponent;
    @ViewChild('appSchoolsCode') appSchoolsCode!: SchoolDropdownComponent;
    @ViewChild('appSchoolDistrictCode') appSchoolDistrictCode!: DistrictDropdownComponent;
    @Input() searchParm: any = [{}];

    // Search variables
    selectedSchoolYear: string = '';
    initialSchoolYear: string = '';
    currentSchoolYear: string = '';
    allRegions: Region[] = [];
    allDistricts: SchoolDistrict[] = [];
    lstSelectedRegion: Region[] = [];
    lstSelecteddistricts: SchoolDistrict[] = [];
    lstSelectedschools: School[] = [];
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenSchools: School[] = [];

    rAttending: boolean = false;
    rNotAttending: boolean = false;

    expiredEligibility: boolean = true;
    expiredQAD: boolean = true;
    notWithdrawnFromSchool: boolean = false;
    k12Ungraded: boolean = false;
    verifiedCoes: boolean = false;

    grades: Grade[] = [];

    isExporting: boolean = false;
    hasExports: boolean = false;

    // Component variables
    resetField: boolean = false;
    progressCurrentValue: number = 10;
    progressValue: number = 10;
    progressMax: number = 200;
    progressSpinnerMax: number = 100;
    progressColor: ThemePalette = 'accent';
    progressType: ProgressSpinnerMode = 'determinate';
    progressSpeed: number = 10;
    progressSubscription: Subscription;
    progressInterval: number = 500;

    lstchosenSchoolDistrict: ChosenSchoolDistrict[] = [];
    lstchosenSchoolRegion: ChosenRegion[] = [];
    lstSearchEnrollmentResponse: EnrollmentReportStudent[];
    strExportFileName = 'Enrollment_Report';
    fileNameLabel: string = '';
    bCheckedStyling: boolean = true;

    // Table display
    columns = {
        Region: { INDEX: 1, ENABLED: false, SORT: 'CODE', DATA: 'CODE', DISABLED: false },
        District: { INDEX: 2, ENABLED: false, SORT: 'DISTRICTS', DATA: 'DISTRICTS', DISABLED: false },
        School: { INDEX: 3, ENABLED: false, SORT: 'NAME', DATA: 'NAME', DISABLED: false },
        'School Year': { INDEX: 4, ENABLED: false, SORT: 'SCHOOL_YEAR', DATA: 'SCHOOL_YEAR', DISABLED: false },
        'School CDS Code': { INDEX: 5, ENABLED: false, SORT: 'CDS_CODE', DATA: 'CDS_CODE', DISABLED: false },

        'MSD Number': { INDEX: 6, ENABLED: true, SORT: 'MSD_NUMBER', DATA: 'MSD_NUMBER', DISABLED: true },
        SSID: { INDEX: 7, ENABLED: true, SORT: 'SSID', DATA: 'SSID', DISABLED: true },

        MSIX: { INDEX: 8, ENABLED: false, SORT: 'MSIX', DATA: 'MSIX', DISABLED: false },
        'SIS ID': { INDEX: 9, ENABLED: false, SORT: 'SISID[0].IDENTIFIER_VALUE', DATA: 'SISID[0].IDENTIFIER_VALUE', DISABLED: false },

        Name: { INDEX: 10, ENABLED: true, SORT: 'PERSON.LAST_NAME', DATA: 'PERSON.LAST_NAME', DISABLED: true },
        DOB: { INDEX: 11, ENABLED: true, SORT: 'DOB', DATA: 'DOB', DISABLED: true },

        Age: { INDEX: 12, ENABLED: false, SORT: 'AGE', DATA: 'AGE', DISABLED: false },

        Gender: { INDEX: 13, ENABLED: true, SORT: 'SEX', DATA: 'SEX', DISABLED: true },
        'Medical Alert': { INDEX: 14, ENABLED: false, SORT: 'HEALTH_NOTE', DATA: 'HEALTH_NOTE', DISABLED: false },

        "Child's Preferred Email": { INDEX: 15, ENABLED: false, SORT: 'PREFERRED_EMAIL.EMAIL_ADDRESS', DATA: 'PREFERRED_EMAIL.EMAIL_ADDRESS', DISABLED: false },
        "Child's Preferred Phone Number": {
            INDEX: 16,
            ENABLED: false,
            SORT: 'PREFERRED_PHONE.PHONE_NUMBER',
            DATA: 'PREFERRED_PHONE.PHONE_NUMBER',
            DISABLED: false
        },

        Ethnicity: { INDEX: 17, ENABLED: false, SORT: 'RACE', DATA: 'RACE', DISABLED: false },
        'COE Number': {
            INDEX: 18,
            ENABLED: false,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].CO.COE_NUMBER',
            DATA: 'STUDENT_ELIGIBILITIES[0].CO.COE_NUMBER',
            DISABLED: false,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        'COE Verified': {
            INDEX: 19,
            ENABLED: false,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].CO.COE_STATUSES[0].COE_STATUS_TYPES.TYPE',
            DATA: 'STUDENT_ELIGIBILITIES[0].CO.COE_STATUSES[0].COE_STATUS_TYPES.TYPE',
            DISABLED: false,
            SCHOOL_ENROLLMENT_DETAILS: true
        },

        Grade: { INDEX: 20, ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].GRADE', DATA: 'GRADE', DISABLED: true, SCHOOL_ENROLLMENT_DETAILS: true },
        QAD: {
            INDEX: 21,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].CO.QUALIFYING_ARRIVAL_DATE',
            DATA: 'STUDENT_ELIGIBILITIES[0].CO.QUALIFYING_ARRIVAL_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        EoE: {
            INDEX: 22,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE',
            DATA: 'STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },

        'EoE Flag': {
            INDEX: 23,
            ENABLED: false,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].expiredEligibility',
            DATA: 'expiredEligibility',
            DISABLED: false,
            EXCEL_EXPORT_ONLY: false,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        'EoE Now Flag': {
            INDEX: 24,
            ENABLED: false,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].EoEToday',
            DATA: 'EoEToday',
            DISABLED: false,
            EXCEL_EXPORT_ONLY: false,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        'Recruiter Sign Date': {
            INDEX: 25,
            ENABLED: false,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].RECRUITER_SIGN_DATE',
            DATA: 'RECRUITER_SIGN_DATE',
            DISABLED: false,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        'Residency Date': {
            INDEX: 26,
            ENABLED: false,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].CO.COE_MOVES[0].RESIDENCY_DATE',
            DATA: 'STUDENT_ELIGIBILITIES[0].CO.COE_MOVES[0].RESIDENCY_DATE',
            DISABLED: false,
            SCHOOL_ENROLLMENT_DETAILS: true
        },

        'Enroll Date': {
            INDEX: 27,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE',
            DATA: 'ENROLLMENT_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        'Withdrawal Date': {
            INDEX: 28,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE',
            DATA: 'WITHDRAWAL_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        'Departure Date': {
            INDEX: 29,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].DEPARTURE_DATE',
            DATA: 'DEPARTURE_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },

        Track: { INDEX: 30, ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].TRACK', DATA: 'TRACK', DISABLED: true, SCHOOL_ENROLLMENT_DETAILS: true },
        'Enroll Type': {
            INDEX: 31,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE',
            DATA: 'ENROLLMENT_TYPE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },

        'Academic Risk': {
            INDEX: 32,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].ACADEMIC_RISK',
            DATA: 'ACADEMIC_RISK',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        PFS: { INDEX: 33, ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].PFS', DATA: 'PFS', DISABLED: true, SCHOOL_ENROLLMENT_DETAILS: true },

        //'COS': { INDEX: 30, ENABLED: false, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].COS', DATA: 'COS', DISABLED: false, SCHOOL_ENROLLMENT_DETAILS: true },

        'Current Address Street 1': { INDEX: 34, ENABLED: false, SORT: 'CURRENT_ADDRESS.STREET_1', DATA: 'CURRENT_ADDRESS.STREET_1', DISABLED: false },
        'Current Address Street 2': { INDEX: 35, ENABLED: false, SORT: 'CURRENT_ADDRESS.STREET_2', DATA: 'CURRENT_ADDRESS.STREET_2', DISABLED: false },
        'Current Address City': { INDEX: 36, ENABLED: false, SORT: 'CURRENT_ADDRESS.CITy.CITY_NAME', DATA: 'CURRENT_ADDRESS.CITy.CITY_NAME', DISABLED: false },
        'Current Address State': {
            INDEX: 37,
            ENABLED: false,
            SORT: 'CURRENT_ADDRESS.CITy.STATE.STATE_NAME',
            DATA: 'CURRENT_ADDRESS.CITy.STATE.STATE_NAME',
            DISABLED: false
        },
        'Current Address ZIP code': {
            INDEX: 38,
            ENABLED: false,
            SORT: 'CURRENT_ADDRESS.POSTAL_CODES.POSTAL_CODE',
            DATA: 'CURRENT_ADDRESS.POSTAL_CODES.POSTAL_CODE',
            DISABLED: false
        },
        'Current Phone': { INDEX: 39, ENABLED: false, SORT: 'CURRENT_PHONE.PHONE_NUMBER', DATA: 'CURRENT_PHONE.PHONE_NUMBER', DISABLED: false },
        'Mailing Address Street 1': { INDEX: 40, ENABLED: false, SORT: 'MAILING_ADDRESS.STREET_1', DATA: 'MAILING_ADDRESS.STREET_1', DISABLED: false },
        'Mailing Address Street 2': { INDEX: 41, ENABLED: false, SORT: 'MAILING_ADDRESS.STREET_2', DATA: 'MAILING_ADDRESS.STREET_2', DISABLED: false },
        'Mailing Address City': { INDEX: 42, ENABLED: false, SORT: 'MAILING_ADDRESS.CITy.CITY_NAME', DATA: 'MAILING_ADDRESS.CITy.CITY_NAME', DISABLED: false },
        'Mailing Address State': {
            INDEX: 43,
            ENABLED: false,
            SORT: 'MAILING_ADDRESS.CITy.STATE.STATE_NAME',
            DATA: 'MAILING_ADDRESS.CITy.STATE.STATE_NAME',
            DISABLED: false
        },
        'Mailing Address ZIP code': {
            INDEX: 44,
            ENABLED: false,
            SORT: 'MAILING_ADDRESS.POSTAL_CODES.POSTAL_CODE',
            DATA: 'MAILING_ADDRESS.POSTAL_CODES.POSTAL_CODE',
            DISABLED: false
        },
        'Mailing Phone': { INDEX: 45, ENABLED: false, SORT: 'MAILING_PHONE.PHONE_NUMBER', DATA: 'MAILING_PHONE.PHONE_NUMBER', DISABLED: false },
        'Current Parent/Guardian 1 FN': { INDEX: 46, ENABLED: false, SORT: 'CURRENT_FATHER.FIRST_NAME', DATA: 'CURRENT_FATHER.FIRST_NAME', DISABLED: false },
        'Current Parent/Guardian 1 LN': { INDEX: 47, ENABLED: false, SORT: 'CURRENT_FATHER.LAST_NAME', DATA: 'CURRENT_FATHER.LAST_NAME', DISABLED: false },
        'Current Parent/Guardian 1 Email': {
            INDEX: 48,
            ENABLED: false,
            SORT: 'CURRENT_FATHER.EMAIL_ADDRESS',
            DATA: 'CURRENT_FATHER.EMAIL_ADDRESS',
            DISABLED: false
        },
        'Current Parent/Guardian 1 Phone Number': {
            INDEX: 49,
            ENABLED: false,
            SORT: 'CURRENT_FATHER.PHONE_NUMBER',
            DATA: 'CURRENT_FATHER.PHONE_NUMBER',
            DISABLED: false
        },
        'Current Parent/Guardian 2 FN': { INDEX: 50, ENABLED: false, SORT: 'CURRENT_MOTHER.FIRST_NAME', DATA: 'CURRENT_MOTHER.FIRST_NAME', DISABLED: false },
        'Current Parent/Guardian 2 LN': { INDEX: 51, ENABLED: false, SORT: 'CURRENT_MOTHER.LAST_NAME', DATA: 'CURRENT_MOTHER.LAST_NAME', DISABLED: false },
        'Current Parent/Guardian 2 Email': {
            INDEX: 52,
            ENABLED: false,
            SORT: 'CURRENT_MOTHER.EMAIL_ADDRESS',
            DATA: 'CURRENT_MOTHER.EMAIL_ADDRESS',
            DISABLED: false
        },
        'Current Parent/Guardian 2 Phone Number': {
            INDEX: 53,
            ENABLED: false,
            SORT: 'CURRENT_MOTHER.PHONE_NUMBER',
            DATA: 'CURRENT_MOTHER.PHONE_NUMBER',
            DISABLED: false
        },
        'Legal Parent/Guardian 1 FN': { INDEX: 54, ENABLED: false, SORT: 'LEGAL_FATHER.FIRST_NAME', DATA: 'LEGAL_FATHER.FIRST_NAME', DISABLED: false },
        'Legal Parent/Guardian 1 LN': { INDEX: 55, ENABLED: false, SORT: 'LEGAL_FATHER.LAST_NAME', DATA: 'LEGAL_FATHER.LAST_NAME', DISABLED: false },
        'Legal Parent/Guardian 1 Email': { INDEX: 56, ENABLED: false, SORT: 'LEGAL_FATHER.EMAIL_ADDRESS', DATA: 'LEGAL_FATHER.EMAIL_ADDRESS', DISABLED: false },
        'Legal Parent/Guardian 1 Phone Number': {
            INDEX: 57,
            ENABLED: false,
            SORT: 'LEGAL_FATHER.PHONE_NUMBER',
            DATA: 'LEGAL_FATHER.PHONE_NUMBER',
            DISABLED: false
        },
        'Legal Parent/Guardian 2 FN': { INDEX: 58, ENABLED: false, SORT: 'LEGAL_MOTHER.FIRST_NAME', DATA: 'LEGAL_MOTHER.FIRST_NAME', DISABLED: false },
        'Legal Parent/Guardian 2 LN': { INDEX: 59, ENABLED: false, SORT: 'LEGAL_MOTHER.LAST_NAME', DATA: 'LEGAL_MOTHER.LAST_NAME', DISABLED: false },
        'Legal Parent/Guardian 2 Email': { INDEX: 60, ENABLED: false, SORT: 'LEGAL_MOTHER.EMAIL_ADDRESS', DATA: 'LEGAL_MOTHER.EMAIL_ADDRESS', DISABLED: false },
        'Legal Parent/Guardian 2 Phone Number': {
            INDEX: 61,
            ENABLED: false,
            SORT: 'LEGAL_MOTHER.PHONE_NUMBER',
            DATA: 'LEGAL_MOTHER.PHONE_NUMBER',
            DISABLED: false
        }
    };
    selectedColumns: string[] = []; //'MSD Number', 'SSID', 'Name', 'DOB','Gender','Grade', 'QAD', 'EoE', 'Enroll Date', 'Withdrawal Date', 'Departure Date', 'Track', 'Enroll Type', 'Academic Risk', 'PFS'
    defaultColumns: string[] = [
        'MSD Number',
        'SSID',
        'Name',
        'DOB',
        'Gender',
        'Grade',
        'QAD',
        'EoE',
        'Enroll Date',
        'Withdrawal Date',
        'Departure Date',
        'Track',
        'Enroll Type',
        'Academic Risk',
        'PFS'
    ];
    baseDisplayedColumns: string[] = [
        'MSD Number',
        'SSID',
        'Name',
        'DOB',
        'Gender',
        'Grade',
        'QAD',
        'EoE',
        'Enroll Date',
        'Withdrawal Date',
        'Departure Date',
        'Track',
        'Enroll Type',
        'Academic Risk',
        'PFS'
    ];
    suffixColumns: string[] = [];
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    // Table results
    tableDataSources: MatTableDataSource<EnrollmentReportStudent>[] = [];

    // Results
    results: EnrollmentReportResult[] = [];
    regions: EnrollmentReportRegion[] = [];
    filter: string = '';
    regionLength: number = 0;
    countyLength: number = 0;
    schoolDistrictLength: number = 0;
    schoolLength: number = 0;
    studentLength: number = 0;

    lstQuestionHelpText: QuestionHelpText[] = [];
    currentSetting: any;
    isLoadingResults: boolean = false;
    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    criterionFilters = {
        'End of Eligibility': {
            INDEX: 1,
            ENABLED: false,
            DATA: 'EndOfEligibility',
            DISABLED: false,
            TOOLTIP: { ID: 0 }
        },
        'Qualifying Arrival Date Anniversary': {
            INDEX: 2,
            ENABLED: false,
            DATA: 'QAD',
            DISABLED: false,
            TOOLTIP: { ID: 0 }
        },
        'Recruitment Anniversary': {
            INDEX: 3,
            ENABLED: false,
            DATA: 'RecruitmentAnniversary',
            DISABLED: false,
            TOOLTIP: { ID: 0 }
        },
        'Turning Age 3': {
            INDEX: 4,
            ENABLED: false,
            DATA: 'TurningAgeThree',
            DISABLED: false,
            TOOLTIP: { ID: 0 }
        }
    };
    chosenCriterionFilter: string = '';
    criterionStartDate = '';
    criterionEndDate = '';

    recruitedSince: boolean = false;
    recruitedSinceStartDate = '';
    recruitedSinceEndDate = '';

    constructor(
        public pagingService: PagingService,
        private dialog: MatDialog,
        private enrollmentReportService: EnrollmentReportService,
        private apiMsinExportsService: ApiExportsService,
        private utilityService: UtilityService,
        private regionDataService: RegionDataService,
        private districtDataService: DistrictDataService
    ) {
        this.deSelectAllColumns(this.columns); // reset the selections at default
        this.selectBaseColumns();
    }

    ngOnInit(): void {
        this.regionDataService.getAll().subscribe({
            next: (data: any) => {
                this.allRegions = data;
            },
            error: (error: any) => {
                console.error('Error fetching regions:', error);
            }
        });

        this.districtDataService.getAll().subscribe({
            next: (data: any) => {
                this.allDistricts = data;
            },
            error: (error: any) => {
                console.error('Error fetching districts:', error);
            }
        });
    }

    isSelected(element: any): boolean {
        return this.selectedColumns.includes(element);
    }

    search() {
        if (this.checkValid() && (this.rAttending || this.rNotAttending)) {
            this.isLoading = true;
            this.msg = {};
            this.filter = '';

            if (this.selectedColumns.length <= 15) {
                this.enrollmentReportService.search(this.generatePayload()).subscribe({
                    next: (res) => {
                        if (res.schools) {
                            this.results = res.schools.sort((n1: EnrollmentReportResult, n2: EnrollmentReportResult) => (n1.NAME! > n2.NAME! ? 1 : -1));

                            let prefixColumns: string[] = [];
                            this.displayedColumns = this.generateDisplayColumns(this.selectedSchoolYear, prefixColumns);
                        } else if (res.msg) {
                            this.results = [];
                            this.msg = res.msg;
                        } else {
                            this.results = [];
                            this.msg = { SUCCESS: false, MSG: 'Error retrieving Enrollment Report.' };
                        }
                    },
                    error: (err) => {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving Enrollment Report.' };
                        this.isLoading = false;
                    },
                    complete: () => {
                        // Display current performance period
                        this.currentSchoolYear = this.selectedSchoolYear;

                        // Updates the Tables to be displayed w/ this.results
                        if (this.results.length > 0) {
                            this.updateDataSource();
                        }

                        // Display results
                        this.isLoading = false;
                    }
                });
            } else {
                this.enrollmentReportService.extendedSearch(this.generatePayload()).subscribe({
                    next: (res) => {
                        if (res.schools) {
                            this.results = res.schools.sort((n1: EnrollmentReportResult, n2: EnrollmentReportResult) => (n1.NAME! > n2.NAME! ? 1 : -1));

                            let prefixColumns: string[] = [];
                            this.displayedColumns = this.generateDisplayColumns(this.selectedSchoolYear, prefixColumns);
                        } else if (res.msg) {
                            this.results = [];
                            this.msg = res.msg;
                        } else {
                            this.results = [];
                            this.msg = { SUCCESS: false, MSG: 'Error retrieving Enrollment Report.' };
                        }
                    },
                    error: (err) => {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving Enrollment Report.' };
                        this.isLoading = false;
                    },
                    complete: () => {
                        // Display current performance period
                        this.currentSchoolYear = this.selectedSchoolYear;

                        // Updates the Tables to be displayed w/ this.results
                        if (this.results.length > 0) {
                            this.updateDataSource();
                        }

                        // Display results
                        this.isLoading = false;
                    }
                });
            }
        } else {
            this.msg = { SUCCESS: false, MSG: 'Please select a School District and an Enrollment Type.' };
        }
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.chosenRegions.map((obj) => obj.ID);
        payload.chosenCounties = this.chosenCounties.map((obj) => obj.ID);
        payload.chosenSchoolDistricts = this.chosenSchoolDistricts.map((obj) => obj.ID);
        payload.chosenSchools = this.chosenSchools.map((obj) => obj.ID);
        payload.schoolYear = this.selectedSchoolYear;

        payload.rAttending = this.rAttending;
        payload.rNotAttending = this.rNotAttending;

        payload.expiredEligibility = this.expiredEligibility;
        payload.expiredQAD = this.expiredQAD;
        payload.notWithdrawnFromSchool = this.notWithdrawnFromSchool;
        payload.k12Ungraded = this.k12Ungraded;
        payload.verifiedCoes = this.verifiedCoes;

        payload.criterion = this.chosenCriterionFilter ? this.chosenCriterionFilter : undefined;
        payload.criterionStartDate = this.criterionStartDate;
        payload.criterionEndDate = this.criterionEndDate;

        payload.recruitedSince = this.recruitedSince;
        payload.recruitedSinceStartDate = this.recruitedSinceStartDate;
        payload.recruitedSinceEndDate = this.recruitedSinceEndDate;

        return payload;
    }

    generateDisplayColumns(schoolYear: string, prefixColumns?: string[]) {
        let displayedColumns: string[] = prefixColumns ? prefixColumns : [];
        let columns: any = this.columns;
        //displayedColumns = displayedColumns.concat(this.baseDisplayedColumns);

        const properties = Object.keys(columns);
        properties.forEach((property) => {
            if (columns[property].ENABLED) {
                displayedColumns.push(columns[property].SORT);
            }
        });

        return displayedColumns;
    }

    updateDataSource() {
        this.tableDataSources = [];
        this.regions = JSON.parse(JSON.stringify(this.chosenRegions));
        this.regions[0].COUNTIES = JSON.parse(JSON.stringify(this.chosenCounties));
        this.regions[0].COUNTIES[0].SCHOOL_DISTRICTS = JSON.parse(JSON.stringify(this.chosenSchoolDistricts));
        this.regions[0].COUNTIES[0].SCHOOL_DISTRICTS[0].SCHOOLS = this.results;

        this.studentLength = 0;

        setTimeout(() => {
            this.regions.forEach((region) => {
                region.countyLength = region.COUNTIES ? region.COUNTIES.length : 0;
                region.schoolDistrictLength = 0;
                region.schoolLength = 0;
                region.studentLength = 0;
                region.enrollmentLength = 0;

                region.COUNTIES.forEach((county) => {
                    region.schoolDistrictLength += county.SCHOOL_DISTRICTS ? county.SCHOOL_DISTRICTS.length : 0;
                    county.schoolDistrictLength = county.SCHOOL_DISTRICTS ? county.SCHOOL_DISTRICTS.length : 0;
                    county.schoolLength = 0;
                    county.studentLength = 0;
                    county.enrollmentLength = 0;

                    county.SCHOOL_DISTRICTS.forEach((schoolDistrict) => {
                        region.schoolLength += schoolDistrict.SCHOOLS ? schoolDistrict.SCHOOLS.length : 0;
                        county.schoolLength += schoolDistrict.SCHOOLS ? schoolDistrict.SCHOOLS.length : 0;
                        schoolDistrict.schoolLength = schoolDistrict.SCHOOLS ? schoolDistrict.SCHOOLS.length : 0;
                        schoolDistrict.studentLength = 0;
                        schoolDistrict.enrollmentLength = 0;

                        schoolDistrict.SCHOOLS.forEach((school, index) => {
                            school.SCHOOL_YEAR = this.currentSchoolYear;

                            region.studentLength += school.STUDENTS ? school.STUDENTS.length : 0;
                            county.studentLength += school.STUDENTS ? school.STUDENTS.length : 0;
                            schoolDistrict.studentLength += school.STUDENTS ? school.STUDENTS.length : 0;
                            school.studentLength = school.STUDENTS ? school.STUDENTS.length : 0;
                            school.enrollmentLength = 0;

                            this.studentLength += school.STUDENTS.length;

                            school.STUDENTS.forEach((student) => {
                                region.enrollmentLength += student.SCHOOL_ENROLLMENT_DETAILS ? student.SCHOOL_ENROLLMENT_DETAILS.length : 0;
                                county.enrollmentLength += student.SCHOOL_ENROLLMENT_DETAILS ? student.SCHOOL_ENROLLMENT_DETAILS.length : 0;
                                schoolDistrict.enrollmentLength += student.SCHOOL_ENROLLMENT_DETAILS ? student.SCHOOL_ENROLLMENT_DETAILS.length : 0;
                                school.enrollmentLength += student.SCHOOL_ENROLLMENT_DETAILS ? student.SCHOOL_ENROLLMENT_DETAILS.length : 0;
                                student.enrollmentLength = student.SCHOOL_ENROLLMENT_DETAILS ? student.SCHOOL_ENROLLMENT_DETAILS.length : 0;

                                // Attach AGE
                                student.AGE = parseInt(new AgePipe().transform(student.DOB).replace(/[{()}]/g, ''));

                                // Attach coeNotVerified, EoEToday, and expiredEligibility
                                student.SCHOOL_ENROLLMENT_DETAILS.forEach((sed) => {
                                    // Attach CDS_CODE
                                    sed.CDS_CODE = school.CDS_CODE;

                                    if (
                                        sed.STUDENT_ELIGIBILITIES &&
                                        sed.STUDENT_ELIGIBILITIES[0].CO &&
                                        sed.STUDENT_ELIGIBILITIES[0].CO.COE_STATUSES &&
                                        sed.STUDENT_ELIGIBILITIES[0].CO.COE_STATUSES[0].COE_STATUS_TYPES &&
                                        !(
                                            sed.STUDENT_ELIGIBILITIES[0].CO.COE_STATUSES[0].COE_STATUS_TYPES.ID == 1 ||
                                            sed.STUDENT_ELIGIBILITIES[0].CO.COE_STATUSES[0].COE_STATUS_TYPES.ID == 3
                                        )
                                    ) {
                                        sed.coeNotVerfied = true;
                                    }

                                    sed.STUDENT_ELIGIBILITIES.forEach((eligibility: any) => {
                                        if (
                                            sed.STUDENT_ELIGIBILITIES &&
                                            sed.STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE &&
                                            new SimpleDatePipe().transform(sed.STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE) ===
                                                new SimpleDatePipe().transform(new Date())
                                        ) {
                                            sed.EoEToday = true;
                                        }

                                        eligibility.STUDENT_ELIGIBILITY_STATUS.forEach((status: any) => {
                                            if (status.ELIGIBILITY_STATUS && status.ELIGIBILITY_STATUS.STATUS === 'INELIGIBLE') {
                                                sed.expiredEligibility = true;
                                            }
                                        });
                                    });
                                });
                            });

                            // Data
                            let dataSource = new MatTableDataSource<EnrollmentReportStudent>();
                            dataSource.data = school.STUDENTS!;

                            // Paginator
                            dataSource.paginator = this.paginators.toArray()[index];

                            // Sort
                            dataSource.sort = this.sorts.toArray()[index];
                            const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
                            dataSource.sort.active = defaultSort.active;
                            dataSource.sort.direction = defaultSort.direction;
                            dataSource.sort.sortChange.emit(defaultSort);
                            dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

                            // Filter
                            dataSource.filterPredicate = (data: any, filter) => {
                                const dataStr = JSON.stringify(data).toLowerCase();
                                return dataStr.indexOf(filter) != -1;
                            };

                            this.tableDataSources.push(dataSource);
                        });
                    });
                });
            });
        });
    }

    setFilter() {
        this.tableDataSources.forEach((dataSource, index) => {
            dataSource.filter = this.filter.trim().toLocaleLowerCase();
        });

        this.expandAll(this.regions);
    }

    expandAll(regions: any[]) {
        regions.forEach((region: any) => {
            region.SHOW = true;
            region.COUNTIES.forEach((county: any) => {
                county.SHOW = true;
                county.SCHOOL_DISTRICTS.forEach((schoolDistrict: any) => {
                    schoolDistrict.SHOW = true;
                    schoolDistrict.SCHOOLS.forEach((school: any) => {
                        school.SHOW = true;
                    });
                });
            });
        });
    }

    collapseAll(regions: any[]) {
        regions.forEach((region: any) => {
            region.SHOW = false;
            region.COUNTIES.forEach((county: any) => {
                county.SHOW = false;
                county.SCHOOL_DISTRICTS.forEach((schoolDistrict: any) => {
                    schoolDistrict.SHOW = false;
                    schoolDistrict.SCHOOLS.forEach((school: any) => {
                        school.SHOW = false;
                    });
                });
            });
        });
    }

    toggleShow(obj: any) {
        obj.SHOW = !obj.SHOW;
    }

    checkValid() {
        if (this.chosenRegions.length > 0 && this.chosenSchoolDistricts.length > 0 && this.selectedSchoolYear) {
            return true;
        }

        return false;
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }

    // Location Emitters
    performancePeriodEvent(performancePeriod: string) {
        this.selectedSchoolYear = performancePeriod;
    }

    // Filter Emiiters
    gradeEventEmitter(grades: Grade[]) {
        this.grades = grades;
    }

    // MISC
    reset() {
        this.resetField = !this.resetField;
        //This is optional code To reset the value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        this.chosenRegions = [];
        this.chosenCounties = [];
        this.chosenSchoolDistricts = [];
        this.chosenSchools = [];

        this.rAttending = false;
        this.rNotAttending = false;
        this.expiredEligibility = true;
        this.expiredQAD = true;
        this.notWithdrawnFromSchool = false;
        this.k12Ungraded = false;
        this.verifiedCoes = false;

        this.chosenCriterionFilter = '';
        this.criterionStartDate = '';
        this.criterionEndDate = '';

        this.recruitedSince = false;
        this.recruitedSinceStartDate = '';
        this.recruitedSinceEndDate = '';
        this.msg = {};

        this.deSelectAllColumns(this.columns);
    }

    announceSortChange(sortState: Sort) {}

    checkbox(properties: string[], obj: any) {
        let columns: any = obj;
        let columnKeys = Object.keys(columns);

        columnKeys = columnKeys.filter((key) => !obj[key].DISABLED);

        columnKeys.forEach((filter: string) => {
            if (properties.indexOf(filter) >= 0) {
                columns[filter].ENABLED = true;
            } else {
                columns[filter].ENABLED = false;
            }
        });
    }

    selectAllColumns(obj: any) {
        let columnKeys = Object.keys(obj);

        let orderedColumns = columnKeys.filter((item) => columnKeys.includes(item)).concat(columnKeys.filter((key) => !columnKeys.includes(key)));

        columnKeys = Array.from(new Set([...columnKeys, ...this.defaultColumns]));

        this.selectedColumns = orderedColumns;

        columnKeys = columnKeys.filter((key) => !obj[key].DISABLED);

        columnKeys.forEach((filter: string) => {
            obj[filter].ENABLED = true;
        });
    }

    selectBaseColumns() {
        this.selectedColumns = this.baseDisplayedColumns;
    }

    deSelectAllColumns(obj: any) {
        this.checkbox([], obj);
        this.selectedColumns = []; // first empty it
        this.selectedColumns = this.defaultColumns;

        let columnKeys = Object.keys(obj);

        columnKeys = columnKeys.filter((key) => !obj[key].DISABLED);

        columnKeys.forEach((filter: string) => {
            obj[filter].ENABLED = false;
        });
    }

    selectionCount(obj: any, key: string) {
        let count: number = 0;

        if (obj[key]) {
            if (obj[key].OPTIONS) {
                obj[key].OPTIONS.forEach((option: any) => {
                    if (option.ENABLED) {
                        count += 1;
                    }
                });
            }
        }

        return count;
    }

    checkCriterionFilter(event: any, criterionFilterButton: any) {
        event.preventDefault();

        setTimeout(() => {
            if (this.chosenCriterionFilter && this.chosenCriterionFilter === criterionFilterButton.value) {
                criterionFilterButton.checked = false;
                this.chosenCriterionFilter = '';
            } else {
                this.chosenCriterionFilter = criterionFilterButton.value;
                criterionFilterButton.checked = true;
            }
        });
    }

    downloadExcel() {
        let payload = this.generateExportPayload('Excel');

        if (payload.data.length > 0) {
            this.isExporting = true;
            this.msg = new MsgModel();

            this.apiMsinExportsService.exportEnrollmentReport(payload).subscribe({
                next: (res2: any) => {
                    const blob = new Blob([res2], { type: 'application/xlsx' });

                    let fileName = this.utilityService.fnMakeFileNameTime(
                        ('Enrollment_Report_' + this.chosenSchoolDistricts[0].DISTRICTS + '_' + this.selectedSchoolYear).replace(/\s+/g, '_')
                    );

                    const renamedFile = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });

                    const url = URL.createObjectURL(renamedFile);

                    const a = document.createElement('a');
                    a.href = url;
                    fileName = fileName.trimLeft();

                    a.download = fileName + '.xlsx';
                    a.click();
                    if (a && a.parentNode === document.body) {
                        document.body.removeChild(a);
                    }

                    URL.revokeObjectURL(url);
                },
                error: (e) => {
                    this.msg = { SUCCESS: false, MSG: 'Error exporting Enrollment Report.' };
                    this.isExporting = false;
                },
                complete: () => {
                    this.isExporting = false;
                }
            });
        }
    }

    downloadCSV() {
        let payload = this.generateExportPayload('CSV');

        if (payload.data.length > 0) {
            this.isExporting = true;
            this.msg = new MsgModel();

            this.apiMsinExportsService.exportEnrollmentReport(payload).subscribe({
                next: (res2: any) => {
                    const blob = new Blob([res2], { type: 'csv' });

                    let fileName = this.utilityService.fnMakeFileNameTime(
                        ('Enrollment_Report_' + this.chosenSchoolDistricts[0].DISTRICTS + '_' + this.selectedSchoolYear).replace(/\s+/g, '_')
                    );

                    const renamedFile = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });

                    const url = URL.createObjectURL(renamedFile);

                    const a = document.createElement('a');
                    a.href = url;
                    fileName = fileName.trimLeft();

                    a.download = fileName + '.csv';
                    a.click();
                    if (a && a.parentNode === document.body) {
                        document.body.removeChild(a);
                    }

                    URL.revokeObjectURL(url);
                },
                error: (e) => {
                    this.msg = { SUCCESS: false, MSG: 'Error exporting Enrollment Report.' };
                    this.isExporting = false;
                },
                complete: () => {
                    this.isExporting = false;
                }
            });
        }
    }

    generateExportPayload(fileType: string) {
        let payload = {
            settings: {
                fileType: fileType,
                selectedColumns: this.selectedColumns,

                chosenRegion: this.chosenRegions[0],
                chosenCounty: this.chosenCounties[0],
                chosenSchoolDistrict: this.chosenSchoolDistricts[0],
                chosenSchools: this.chosenSchools,
                countRegions: this.chosenRegions.length,
                countCounties: this.regions[0].COUNTIES.length,
                countDistricts: this.regions[0].COUNTIES[0].SCHOOL_DISTRICTS.length,
                countSchools: this.regions[0].schoolLength,
                countEnrollments: this.regions[0].enrollmentLength,
                countChildren: this.regions[0].studentLength,
                schoolYear: this.selectedSchoolYear
            },
            data: this.tableDataSources.flatMap((ds) =>
                ds.data.flatMap((item) =>
                    (item.SCHOOL_ENROLLMENT_DETAILS || []).map((detail) => ({
                        ...item,
                        SCHOOL_ENROLLMENT_DETAILS: [detail],
                        REGION: this.chosenRegions[0],
                        COUNTY: this.chosenCounties[0],
                        SCHOOL_DISTRICT: this.chosenSchoolDistricts[0],
                        SCHOOL_YEAR: this.currentSchoolYear
                    }))
                )
            )
        };

        return payload;
    }
}
